import UserTasks from '@/views/UserTasks/Index'
import UserTasksUserTasks from '@/views/UserTasks/UserTasks/Index'

export default [
    {
        path: '/user-tasks',
        name: 'userTasks',
        component: UserTasks,
        meta: {
            title: 'Zadania',
            menuRendered: true,
            menuTitle: 'Zadania',
            permission: 'user_tasks_read',
            icon: 'mdi-clipboard-check-outline',
            badge: {
                name: 'userTasksCount',
                count: null
            }
        },
        redirect: { name: 'userTasksUserTasks' },
        children: [
            {
                path: '/user-tasks/user-tasks',
                name: 'userTasksUserTasks',
                component: UserTasksUserTasks,
                meta: {
                    title: 'Zadania / Lista zadań',
                    menuTitle: 'Lista zadań',
                    requiresAuth: true,
                    permission: 'user_tasks_read'
                }
            }
        ]
    }
]